import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { MyReportsPreferences } from '../../../shared-components/user-preferences/my-reports-preferences.model';
import { UserPreferencesService } from '../../../shared-components/user-preferences/user-preferences.service';
import { ReportQueueComponent } from '../../../shared-modules/reporting/report-queue/report-queue.component';
import { ReportingComponent } from '../../../shared-modules/reporting/reporting.component';
import { AssignedReports, MyReportsFolder } from '../reporting-framework.model';
import { ReportingFrameworkService } from '../reporting-framework.service';
import { AddMyReportFolderDialogComponent } from './add-my-report-folder-dialog/add-my-report-folder-dialog.component';

@Component({
  selector: 'app-my-reports',
  templateUrl: './my-reports.component.html',
  styleUrls: ['./my-reports.component.css']
})
export class MyReportsComponent implements OnInit {

  selectionIndex: number;
  tabNames = ['My Reports'];
  tabIndex = null;
  reportsDialogRef: MatDialogRef<ReportingComponent>;
  myReportsFolders: MyReportsFolder[] = [];

  subscriptions: Subscription[] = [];

  assignedReportFolders: AssignedReports[] = [];
  myReportsPreferences: MyReportsPreferences;
  showAsDialog = false;

  constructor(
    private dialog: MatDialog,
    private reportingFrameworkService: ReportingFrameworkService,
    private userPreferenceService: UserPreferencesService,
    private dialogRef: MatDialogRef<MyReportsComponent>

  ) { }

  ngOnInit() {
    this.getMyReportsPreferences();
  }

  getMyReportsPreferences() {
    this.userPreferenceService.getUserPreferences(0, '/OneSISMyReports', 0, '', false).subscribe(results => {
      this.myReportsPreferences = JSON.parse(results[0]);
      this.getTabsData(true);
    });
  }

  getTabsData(byOnInit = false) {
    this.subscriptions.push(
      forkJoin(
        this.reportingFrameworkService.getMyReportsFolders(),
        this.reportingFrameworkService.getAssignedReportFolders(false)
      ).pipe(take(1)).subscribe(results => {
        this.myReportsFolders = results[0];

        this.assignedReportFolders = results[1];


        if (byOnInit == true) {
          this.tabNames.push('Assigned Reports');

          if (this.tabNames.length > 0) {
            this.tabIndex = this.tabNames;
            let i = 0;
            this.tabNames.forEach(element => {
              if (element == 'My Reports') {
                element = 'MyReports';
              }
              if (element == 'Assigned Reports') {
                element = 'AssignedReports';
              }
              this.tabIndex[element] = i;
              i++;
            });
          }

          // tab setup..ONE-11931
          // If the user has both My Reports and Assigned Reports folders setup, the page will default to what is set on the option below (Fig 2)
          if (this.myReportsFolders.length > 0 && this.assignedReportFolders.length > 0) {
            if (this.myReportsPreferences != undefined && this.myReportsPreferences.DefaultTab != undefined) {
              this.selectionIndex = this.myReportsPreferences.DefaultTab;
            } else {
              this.selectionIndex = 0;
            }
          }
          // If the user has no Assigned Reports folder setup and has My Reports folders setup, the My Reports page will default to the My Reports tab
          else if (this.myReportsFolders.length > 0 && this.assignedReportFolders.length == 0) {
            this.selectionIndex = 0;
          }
          // If the user has no My Reports folder setup and has Assigned Reports folders setup, the My Reports page will default to the Assigned Reports tab
          else if (this.myReportsFolders.length == 0 && this.assignedReportFolders.length > 0) {
            this.selectionIndex = 1;
          }
          // If the user has neither setup, the My Reports page will default to the My Reports tab
          else if (this.myReportsFolders.length == 0 && this.assignedReportFolders.length == 0) {
            this.selectionIndex = 0;
          }

        }

      }));
  }

  addFolderClick() {
    const dialogBox = this.dialog.open(AddMyReportFolderDialogComponent, {
      width: '35vw',
      disableClose: true
    });
    dialogBox.componentInstance.dialogTitle = 'Add Folders';
    dialogBox.componentInstance.editMode = false;
    dialogBox.componentInstance.myReportFolder = new MyReportsFolder();
    dialogBox.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.getTabsData();
      }
    });
  }

  allReportsClick() {
    this.reportsDialogRef = this.dialog.open(ReportingComponent, {
      panelClass: 'tyl-mat-dialog',
    });
  }

  openQueueList() {
    const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
  });
  }

  closeClick() {
    this.dialog.closeAll();
  }

}
